<template lang="">
  <div class="fllow-item">
    <van-field
      :value="item.type | enumMessage(AllEnums.CRM_FOLLOW_UP_TYPE)"
      readonly
      input-align="right"
      label="跟进类型"
    />
    <van-field
      :value="item.creatorName | dash"
      readonly
      input-align="right"
      label="跟进人"
    />
    <van-field
      :value="item.content | dash"
      type="textarea"
      autosize
      readonly
      input-align="right"
      label="跟进内容"
    />
    <van-field
      :value="item.nextTime | dateFormat('YYYY-MM-DD')"
      readonly
      input-align="right"
      label="下次联系时间"
    />
    <van-field
      readonly
      input-align="right"
      v-if="item.picUrls && item.picUrls.length"
      label-width="60px"
      label="图片"
    >
      <template #input>
        <Uploader
          accept="image/*,video/*,audio/*"
          multiple
          readonly
          v-model="item.picUrls"
        />
      </template>
    </van-field>
    <div v-if="isUser && item.contacts && item.contacts.length">
      <van-cell title="关联联系人"></van-cell>
      <van-cell
        class="concact-item"
        v-for="(i, index) in item.contacts"
        :key="index"
        :title="setConcatName(index, i)"
        @click="toDetail(i)"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
    isUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    setConcatName(index, i) {
      let { name, post, mobile } = i;
      return `${index + 1}、${[name, post, mobile].filter(Boolean).join("-")}`;
    },
    toDetail(item) {
      this.$router.push({
        path: "/relation/create",
        query: {
          id: item.id,
          customerId: this.detailInfo.id,
          name: this.detailInfo.name,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.fllow-item {
  margin-top: 10px;
}
.concact-item{
  /deep/span{
    color: #3c86ff;
  }
}
</style>
